import createApi from "../utils/apiClient";
const api = createApi();

export const getHostels = () => async (dispatch) => {
  try {
    dispatch({ type: "HOSTEL_REQUEST" });
    const { data } = await api.get("/hostel");
    dispatch({ type: "GET_HOSTELS_SUCCESS", payload: data.hostels });
  } catch (err) {
    dispatch({ type: "HOSTEL_FAIL", payload: err.response?.data?.message });
  }
};

export const getAllocations = () => async (dispatch) => {
  try {
    dispatch({ type: "HOSTEL_REQUEST" });
    const { data } = await api.get("/hostel/allocations");
    dispatch({ type: "GET_ALLOCATIONS_SUCCESS", payload: data.allocations });
  } catch (err) {
    dispatch({ type: "HOSTEL_FAIL", payload: err.response?.data?.message });
  }
};

// Not a redux-state action — just returns sorted suggestions for the allocate modal.
export const suggestRooms = (student_id) => async () => {
  const { data } = await api.get("/hostel/suggest", { params: { student_id } });
  return data.rooms;
};

export const createHostel = (formData) => async (dispatch) => {
  try {
    const { data } = await api.post("/hostel", formData);
    await dispatch(getHostels());
    return data;
  } catch (err) {
    throw err;
  }
};

export const updateHostel = (id, formData) => async (dispatch) => {
  try {
    const { data } = await api.put(`/hostel/${id}`, formData);
    await dispatch(getHostels());
    return data;
  } catch (err) {
    throw err;
  }
};

export const deleteHostel = (id) => async (dispatch) => {
  try {
    const { data } = await api.delete(`/hostel/${id}`);
    await dispatch(getHostels());
    return data;
  } catch (err) {
    throw err;
  }
};

export const createRoom = (formData) => async (dispatch) => {
  try {
    const { data } = await api.post("/hostel/rooms", formData);
    await dispatch(getHostels());
    return data;
  } catch (err) {
    throw err;
  }
};

export const updateRoom = (id, formData) => async (dispatch) => {
  try {
    const { data } = await api.put(`/hostel/rooms/${id}`, formData);
    await dispatch(getHostels());
    return data;
  } catch (err) {
    throw err;
  }
};

export const deleteRoom = (id) => async (dispatch) => {
  try {
    const { data } = await api.delete(`/hostel/rooms/${id}`);
    await dispatch(getHostels());
    return data;
  } catch (err) {
    throw err;
  }
};

export const allocateRoom = (formData) => async (dispatch) => {
  try {
    const { data } = await api.post("/hostel/allocate", formData);
    await Promise.all([dispatch(getHostels()), dispatch(getAllocations())]);
    return data;
  } catch (err) {
    throw err;
  }
};

export const vacateAllocation = (id) => async (dispatch) => {
  try {
    const { data } = await api.put(`/hostel/vacate/${id}`);
    await Promise.all([dispatch(getHostels()), dispatch(getAllocations())]);
    return data;
  } catch (err) {
    throw err;
  }
};
